var _tspan;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOutlineFour = function SvgOutlineFour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 152"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "outline-four_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20329",
    transform: "translate(-7 373)",
    style: {
      fill: "none"
    },
    d: "M0 0h100v152H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 216",
    transform: "translate(7 -373)",
    style: {
      clipPath: "url(#outline-four_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": 4,
    transform: "translate(33 497.5)",
    style: {
      stroke: "currentColor",
      strokeWidth: 4,
      fontSize: 140,
      fontFamily: "Sarabun-Bold,Sarabun",
      fontWeight: 700,
      letterSpacing: "-.1em",
      fill: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")))));
};

export default SvgOutlineFour;